/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	"use strict";
	/*globals Tc */

	/**
	 * Tablesorter
	 *
	 * @author Roland Rüger
	 * @namespace Tc.Module
	 * @class TableSorter
	 * @extends Tc.Module
	 */

	Tc.Module.TableSorter = Tc.Module.extend({

		/**
		 * Inititialize
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			if (!SCS.utils.isMobilePage()){

				$ctx.find('table').tablesorter({
					headers: {
						2: {sorter: false},
						3: {sorter: false}
					},
					sortList: [[0,0]]
				});

				$ctx.find('.sorter-false').empty();
			}

			callback();
		}
	});
}(Tc.$, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.js
// module id = 186
// module chunks = 0